document.addEventListener("DOMContentLoaded", function () {

  const section = document.querySelector(".HomeLovedSection");
  if (!section) return;

  let initialized = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !initialized) {
        initialized = true;
        initLovedSwiper(section);
        observer.disconnect();
      }
    });
  }, {
    threshold: 0.25
  });

  observer.observe(section);

  function initLovedSwiper(section) {

    const swiperEl = section.querySelector(".lovebySiwper");
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        nextEl: section.querySelector(".loveby_arrow_right"),
        prevEl: section.querySelector(".loveby_arrow_left"),
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: true
      },
      breakpoints: {
        600: { slidesPerView: 2, spaceBetween: 20 },
        850: { slidesPerView: 2.5 },
        1300: { slidesPerView: 3, spaceBetween: 40 },
      },
    });
  }

});
